export default class AsyncUtils {
  static delayAction(callback, delayMs) {
    setTimeout(callback, delayMs);
  }

  static delayAndAggregateAction(callback, delayMs, aggregationId) {
    if (AsyncUtils.aggregations === undefined)
      AsyncUtils.aggregations = {};

    var aggregation = AsyncUtils.aggregations[aggregationId];
    if (aggregation !== undefined)
      return;

    aggregation = {
      callback: callback,
      delayMs: delayMs,
      aggregationId: aggregationId
    };

    AsyncUtils.aggregations[aggregationId] = aggregation;
    aggregation.timeOut = setTimeout(AsyncUtils.aggregationCallback, delayMs, aggregation);
  }

  static aggregationCallback(aggregation) {
    AsyncUtils.aggregations[aggregation.aggregationId] = undefined;
    aggregation.callback();
  }
}